export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
export const ERROR_MESSAGES = {
    400: `Une erreur est survenue. Veuillez vérifier vos paramètres et réessayer. Si l'erreur persiste veuillez contacter le support.`,
    401: 'Non autorisé. Veuillez vous connecter pour accéder à cette ressource.',
    // add more status codes and error messages as needed
}
